module.exports = __webpack_public_path__ + "static/img/z1.79ecf1d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/iot/z1.png
// module id = 2PS6
// module chunks = 0